"use strict";

exports.__esModule = true;
exports["default"] = Healthcare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Healthcare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M176.3 79.8c0-8.4 8-15.9 15.9-15.9h127.5c8 0 15.9 7.6 15.9 15.9v63.7h31.9V79.8c0-25-23.9-47.8-47.8-47.8H192.2c-23.9 0-47.8 22.7-47.8 47.8v63.7h31.9V79.8zm239.1 79.6H96.6C44 159.4 1 200 1 255v127.4c0 55 27.1 95.6 79.7 95.6h350.6c52.6 0 79.7-40.5 79.7-95.6V255c0-55-43-95.6-95.6-95.6zm-63.8 191.2h-63.8v63.7H224v-63.7h-63.7v-63.7H224v-63.7h63.8v63.7h63.8v63.7z"
  }));
}